export default "/images/276eb5fd1f10dbbde2ca9c81d1167705.avif";